"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Reset File': 'Reset File',
            'Or': 'Or',
            'Added': 'Added',
            'Files Added': 'Files Added',
            'Browse Files': 'Browse Files',
            'One or more files could not be added ': 'One or more files could not be added',
            'Drop a file to upload': 'Drop a file to upload'
        }
    },
    'es': {
        'translation': {
            'Reset File': 'Restablecer Archivos',
            'Or': 'O',
            'Added': 'Adicional',
            'Files Added': 'Agregar Archivos',
            'Browse Files': 'Browse Files',
            'One or more files could not be added ': 'One or more files could not be added',
            'Drop a file to upload': 'Drop a file to upload'
        }
    },
    'cs': {
        'translation': {
            'Reset File': 'Reset File',
            'Or': 'nebo',
            'Added': 'nahráno',
            'Files Added': 'Files Added',
            'Browse Files': 'Procházet',
            'One or more files could not be added': 'One or more files could not be added',
            'Drop a file to upload': 'Přetáhněte soubor'
        }
    },
    'zh': {
        'translation': {
            'Reset File': '重设档案',
            'Or': '或',
            'Added': '新增',
            'Files Added': 'Files Added',
            'Browse Files': '浏览文件',
            'One or more files could not be added': 'One or more files could not be added',
            'Drop a file to upload': '删除要上传的文件'
        }
    },
    'he': {
        'translation': {
            'Reset File': 'הסר',
            'Or': 'או',
            'Added': 'התווסף',
            'Files Added': 'Files Added',
            'Browse Files': 'Browse Files',
            'One or more files could not be added ': 'One or more files could not be added',
            'Drop a file to upload': 'Drop a file to upload'
        }
    }
};
